import React, { Component } from "react";
import PropTypes from "prop-types";
import StarterCampaignPreviewStep from "./StarterCampaignPreviewStep";

export class StarterCampaignPreview extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    templates: PropTypes.array,
    smsTemplates: PropTypes.array
  };

  constructor(props) {
    super(props);
  }

  renderSteps(version) {
    const { steps } = version;
    return steps.map((step, index) => {
      return (
        <StarterCampaignPreviewStep
          key={step.id}
          templates={this.props.templates}
          smsTemplates={this.props.smsTemplates}
          step={step}
          index={index}
        />
      );
    });
  }

  render() {
    const { campaign } = this.props;
    const version = campaign.versions.find(v => v.status == "Active") || {};
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Step No.</th>
            <th>Wait Period</th>
            <th>Type</th>
            <th>Template/Title</th>
            <th />
          </tr>
        </thead>
        {this.renderSteps(version)}
      </table>
    );
  }
}

export default StarterCampaignPreview;
